import { render, staticRenderFns } from "./assignInfo.vue?vue&type=template&id=3b227284&scoped=true"
import script from "./assignInfo.vue?vue&type=script&lang=js"
export * from "./assignInfo.vue?vue&type=script&lang=js"
import style0 from "./assignInfo.vue?vue&type=style&index=0&id=3b227284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b227284",
  null
  
)

export default component.exports